import * as styleHelpers from "@affinity/constants/StyleHelpers";
import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: ${styleHelpers.rem(880)};
    margin: 0 auto;
    padding: ${styleHelpers.rem(20)} 0;
    gap: ${styleHelpers.rem(20)};
    @media (min-width: ${styleHelpers.breakpointWidth("md")}) {
        padding: ${styleHelpers.rem(30)} 0;
        gap: ${styleHelpers.rem(30)};
    }
    @media (min-width: ${styleHelpers.breakpointWidth("lg")}) {
        padding: ${styleHelpers.rem(40)} 0;
        gap: ${styleHelpers.rem(40)};
    }
`;
